<template>
    <div class="block-editor ikas-select-order">
        <section v-if="!channel">
            <a-result status="warning" title="Ikas API not connected">
                <template #extra>
                    <div class="d-flex align-items-center justify-content-center">
                        <SupsisButton primary ghost @click="gotoIkas"> Connect to Ikas</SupsisButton>
                    </div>
                </template>
            </a-result>
        </section>
        <template v-else>
            <section class="active-connection">
                <div data-small="true" class="logos">
                    <div class="logo1">
                        <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                    </div>
                    <span class="material-icons"> add </span>
                    <div class="logo2">
                        <IkasIcon style="width:30px" />
                    </div>
                </div>
                <div class="active-connection-text">
                    <div><span>Connected with</span> <b>Ikas</b></div>
                </div>
            </section>
            <div class="ikas-select-order-wrapper">
                <div class="inputTitle">Ikas Customer ID</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        v-model="clone.customerId"
                        :show-attributes="true"
                        :max-character-count="64"
                        :show-emoji="false"
                        placeholder="Customer ID"
                        :rows="1"
                    />
                </div>
            </div>
            <div class="ikas-select-order-wrapper">
                <div class="inline-field">
                    <div class="inputTitle">Tamamlanan siparişleri de dahil et</div>
                    <a-switch v-model="clone.includeCompleted" />
                </div>
            </div>
            <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
            <section class="next-step-filled-items-wrapper">
                <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                    <AttributeIconPreview :attribute="attr" />
                    <span class="ml-2">
                        <AttributeLabel :attribute="attr" />
                    </span>
                </div>
            </section>
        </template>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";
import _ from "lodash";
import { mapState } from "vuex";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import IkasIcon from "../../../integrations/svg/IkasIcon.vue";

const log = log2("IkasSelectOrder");
export default {
    name: "IkasSelectOrder",
    components: { SupsisButton, TiptapEditor, AttributeLabel, AttributeIconPreview, IkasIcon },
    props: {
        value: {
            type: Object,
            default: () => ({ customerId: "{{ikas_customer_id}}" }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: [
                "ikas_order_id",
                "ikas_order_number",
                "ikas_order_status",
                "ikas_order_price",
                "ikas_order_date",
                "ikas_currency",
                "ikas_order_products",
            ],
        };
    },
    computed: {
        ...mapState({
            channel: (state) => state.channel.channels.find((x) => x.type === "ikas"),
        }),
    },
    methods: {
        gotoIkas() {
            this.$router.push("/integrations/ikas");
        },
    },
    mounted() {
        log("mounted");
        if (typeof this.clone.includeCompleted === "undefined") {
            this.$set(this.clone, "includeCompleted", false);
        }
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) return;
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.ikas-select-order {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: #fff;
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;
        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .ikas-select-order-wrapper {
        .inline-field {
            display: flex;
            align-items: center;
            margin-top: 20px;
        }
        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .inline-field .inputTitle {
            margin-bottom: 0;
            margin-right: 10px;
        }

        .editable-editor {
            p { margin-bottom: 0; }
        }
    }
}
</style>
